import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

const PermissionAccess = () => {
  const authData = useSelector((state) => state.authReducer.authData);
  const location = useLocation();
  const [current_module, setCurrent_module] = useState({});
  let accessPages = [];
  let super_admin = false;
  let moduleDetails = authData?.userData?.role_details?.all_module_details;

  useEffect(() => {
    AdminAccess();
  }, [authData, location.pathname]);

  if (authData?.userData?.role_details?.super_admin === true) {
    super_admin = true;
  } else {
    if (Array.isArray(moduleDetails)) {
      accessPages = moduleDetails.map(module => module.route);
    }
  }

  const normalizeId = (value) => {
    if (!value) return "";
    if (typeof value === "string") return value;
    if (typeof value === "object" && value.$oid) return value.$oid;
    if (typeof value === "object" && value.toString) return value.toString();
    return String(value);
  };

  const normalizeRoute = (route = "") =>
    String(route).replace(/^\/+|\/+$/g, "").toLowerCase();

  const AdminAccess = () => {
    const stored_user = authData?.userData;
    console.log("All Access : ", moduleDetails);
    let Access_Pages = [];
    if (moduleDetails) {
      Access_Pages = moduleDetails;
    }
    const currentRoute = normalizeRoute(window.location.pathname);
    let Current_Page;
    Access_Pages.forEach((page) => {
      if (normalizeRoute(page?.route) === currentRoute) {
        Current_Page = page;
      }
    });
    let role_modules = stored_user?.role_details?.role_modules;
    if (role_modules) {
      let matchedModule = null;
      role_modules.forEach(role => {
        if (normalizeId(role?.module_id) === normalizeId(Current_Page?._id)) {
          matchedModule = role;
        }
      });
      setCurrent_module(matchedModule || {});
    } else {
      setCurrent_module({});
    }
  };

  return { authData, accessPages, super_admin, current_module };
};

export default PermissionAccess;